import OtherComponent from '@components/other';
import * as React from 'react';

export interface IOtherpageProps {}

export default function Otherpage(props: IOtherpageProps) {
  return <OtherComponent />;
}
